import dayjs from "dayjs";
import { useIntl } from "react-intl";
import { StarsRating } from "@/components/common/reviewsBlockV1/ratingInStars/StarsRating";
import { VerifiedIcon } from "@/public/icons/Verified";
import { ClientReview } from "@/components/common/reviewsBlockV1/ReviewsBlock";
import { routes } from "@/routes/routes";
import styles from "./ReviewCard.module.scss";

export type ReviewProps = {
  review: ClientReview;
};

const onAgencyClick = (agencySlug: string | null) => {
  if (agencySlug === null) {
    window.open(routes.agencies, "_blank", "noopener,noreferrer");
  } else {
    window.open(`agences/${agencySlug}`, "_blank", "noopener,noreferrer");
  }
};

export const ReviewCard = ({ review }: ReviewProps) => {
  const intl = useIntl();

  return (
    <div className={styles.reviewCard}>
      <div className={styles.header}>
        <div className={styles.author}>{review.author}</div>
        <div className={styles.verified}>
          <VerifiedIcon size="14" color="#12703D" />
          {intl.formatMessage({ id: "verifiedReview" })}
        </div>
      </div>
      <div className={styles.rating}>
        <StarsRating rating={review.rating} starSize={13} spacing={5} />
      </div>
      <div className={styles.text}>{review.text}</div>
      <div className={styles.date}>
        {intl.formatMessage(
          { id: "reviewDate" },
          { date: dayjs(review.date).format("DD/MM/YYYY") }
        )}
      </div>
      <div
        className={styles.agencyName}
        onClick={() => onAgencyClick(review.agencySlug)}
      >
        {review.agencyName}
      </div>
    </div>
  );
};
